import { useState, useEffect, useRef } from 'react';
import KRGlue from '@lyracom/embedded-form-glue';
import { Systempay } from '../../services/systempay.service';
import Helper from '../../services/helper.service';
import { useTranslation } from 'react-i18next';
import * as _ from 'lodash';
import Loading from '../Loading/loading';
import Hr from '../Style/hr';

export default function SystempayComponent({ data, returnedData, stepBack = "step3" }) {
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const isInitialRender = useRef(true);

    function getLanguage(language) {
        switch (language) {
            case 'fr':
                return 'fr-FR';
            case 'en':
            default:
                return 'en-US';
        }
    }

    useEffect(() => {
        // Check if it's the first render
        if (isInitialRender.current) {
            isInitialRender.current = false;  // Set to false after first render
            async function setupPaymentForm() {
                const endpoint = 'https://api.systempay.fr/';

                const handleReturnedData = (status) => {
                    returnedData(status);
                };

                try {
                    const res = await Systempay.createPayment(data);

                    const formToken = res.data.formToken;
                    const publicKey = res.data.publicKey;

                    const { KR } = await KRGlue.loadLibrary(endpoint, publicKey);

                    // Remove any previously rendered forms to avoid the CLIENT_725 error
                    await KR.removeForms();

                    await KR.setFormConfig({
                        formToken: formToken,
                        'kr-language': getLanguage(data.language)
                    });

                    await KR.renderElements('#myPaymentForm');
                    setLoading(false);

                    // Listen for payment success
                    KR.onSubmit((response) => {
                        if (_.get(response, 'clientAnswer.orderStatus') === 'PAID') {
                            Helper.toast(t('responses.successPayment'), 'success');
                            handleReturnedData({ step: 'paid' });
                        }
                    });

                } catch (error) {
                    setMessage(error + ' (see console for more details)');
                    setLoading(false);

                    console.error('Payment form setup error:', error);
                }
            }

            setupPaymentForm();
        }
    }, [t, data, returnedData]);


    return (
        <div className="w-full max-w-5xl">

            {loading && (
                <div className='w-full'>
                    <div className="py-12">
                        <Loading />
                    </div>
                    <Hr />
                </div>
            )}

            <div className='form mx-auto px-4 sm:px-6 lg:px-8'>
                <div className="container">
                    <div id="myPaymentForm" className="flex justify-center">
                        <div className="kr-smart-form" kr-card-form-expanded="false"></div>
                    </div>
                    <div data-test="payment-message" className="mt-4 text-center text-red-500">{message}</div>
                </div>
            </div>

            <div className='flex justify-start w-full'>
                <button
                    type="button"
                    onClick={() => returnedData({ step: stepBack })}
                    className="btn mt-12 btn-white border border-primary text-primary text-sm py-3 px-6 rounded-xl hover:bg-primary hover:text-white transition"
                >
                    {t('inputs.back')}
                </button>
            </div>
        </div>
    );
}